// ./src/contexts/PoliciesContext/PoliciesContext.tsx
//
// Thin context wrapper around the usePolicies hook. All derived data lives in
// the hook itself. See HighlightsContext for the pattern.

import React, { createContext, useContext } from "react";

import { usePolicies, UsePoliciesOptions, UsePoliciesReturn } from "@/hooks/usePolicies";

const PoliciesContext = createContext<UsePoliciesReturn | null>(null);

export interface PoliciesProviderProps extends UsePoliciesOptions {
  children: React.ReactNode;
}

export const PoliciesProvider: React.FC<PoliciesProviderProps> = ({ children, ...options }) => {
  const value = usePolicies(options);

  return <PoliciesContext.Provider value={value}>{children}</PoliciesContext.Provider>;
};

export const usePoliciesContext = (): UsePoliciesReturn => {
  const context = useContext(PoliciesContext);

  if (!context) {
    throw new Error(
      "usePoliciesContext must be used within a <PoliciesProvider>. " +
        "Wrap your component tree with <PoliciesProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalPoliciesContext = (): UsePoliciesReturn | null => {
  return useContext(PoliciesContext);
};
